import { motion } from 'framer-motion'
import SEO from '../components/SEO'
import { FaFilm } from 'react-icons/fa'

const videos = [
  {
    title: "【无需U盘】Windows重装系统教程（10分钟装好）",
    description: "教你如何在不使用U盘的情况下，快速重装Windows系统，只需10分钟即可完成。",
    thumbnail: (
      <svg width="320" height="180" viewBox="0 0 320 180" className="rounded-lg">
        <defs>
          <pattern id="pattern1" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
            <path d="M0 10h20M10 0v20" stroke="#e2e8f0" strokeWidth="1"/>
          </pattern>
        </defs>
        <rect width="320" height="180" fill="#f8fafc"/>
        <rect width="320" height="180" fill="url(#pattern1)"/>
        <circle cx="160" cy="90" r="40" fill="#3b82f6" opacity="0.1"/>
        <circle cx="160" cy="90" r="30" fill="#3b82f6" opacity="0.2"/>
        <circle cx="160" cy="90" r="20" fill="#3b82f6" opacity="0.3"/>
        <text x="160" y="90" textAnchor="middle" fill="#1e40af" fontSize="24" fontFamily="Arial" fontWeight="bold">
          ⚡
        </text>
        <text x="160" y="120" textAnchor="middle" fill="#1e40af" fontSize="14" fontFamily="Arial">
          10分钟快速重装
        </text>
      </svg>
    ),
    videoUrl: "https://www.bilibili.com/video/BV1qf4y1776C/",
    level: "入门"
  },
  {
    title: "2024年，U盘安装Win11系统完整流程",
    description: "详细讲解如何使用U盘安装Windows 11系统，从制作启动盘到系统激活的全过程。",
    thumbnail: (
      <svg width="320" height="180" viewBox="0 0 320 180" className="rounded-lg">
        <defs>
          <pattern id="pattern2" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
            <circle cx="10" cy="10" r="2" fill="#e2e8f0"/>
          </pattern>
        </defs>
        <rect width="320" height="180" fill="#f8fafc"/>
        <rect width="320" height="180" fill="url(#pattern2)"/>
        <rect x="120" y="60" width="80" height="60" rx="10" fill="#3b82f6" opacity="0.2"/>
        <rect x="130" y="70" width="60" height="40" rx="5" fill="#3b82f6" opacity="0.3"/>
        <text x="160" y="140" textAnchor="middle" fill="#1e40af" fontSize="16" fontFamily="Arial">
          Win11 安装指南
        </text>
      </svg>
    ),
    videoUrl: "https://www.bilibili.com/video/BV1bt421L7t1/",
    level: "入门"
  },
  {
    title: "Mac系统重装指南（不抹盘）｜2023版",
    description: "教你如何在不抹除数据的情况下重装macOS系统，安全又便捷。",
    thumbnail: (
      <svg width="320" height="180" viewBox="0 0 320 180" className="rounded-lg">
        <defs>
          <pattern id="pattern3" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
            <path d="M0 0l20 20M20 0l-20 20" stroke="#e2e8f0" strokeWidth="1"/>
          </pattern>
        </defs>
        <rect width="320" height="180" fill="#f8fafc"/>
        <rect width="320" height="180" fill="url(#pattern3)"/>
        <circle cx="160" cy="90" r="30" fill="#3b82f6" opacity="0.1"/>
        <path d="M160 70 L190 110 L130 110 Z" fill="#3b82f6" opacity="0.3"/>
        <text x="160" y="140" textAnchor="middle" fill="#1e40af" fontSize="16" fontFamily="Arial">
          Mac 重装教程
        </text>
      </svg>
    ),
    videoUrl: "https://www.bilibili.com/video/BV1j94y1q7q6",
    level: "入门"
  },
  {
    title: "如何创建可引导的macOS安装器并重装macOS系统",
    description: "详细讲解如何制作macOS启动盘并完成系统重装。",
    thumbnail: (
      <svg width="320" height="180" viewBox="0 0 320 180" className="rounded-lg">
        <defs>
          <pattern id="pattern4" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
            <rect x="0" y="0" width="10" height="10" fill="#e2e8f0"/>
          </pattern>
        </defs>
        <rect width="320" height="180" fill="#f8fafc"/>
        <rect width="320" height="180" fill="url(#pattern4)"/>
        <rect x="120" y="60" width="80" height="60" rx="10" fill="#3b82f6" opacity="0.2"/>
        <circle cx="160" cy="90" r="20" fill="#3b82f6" opacity="0.3"/>
        <text x="160" y="140" textAnchor="middle" fill="#1e40af" fontSize="16" fontFamily="Arial">
          macOS 安装器制作
        </text>
      </svg>
    ),
    videoUrl: "https://www.bilibili.com/video/BV1RY4y1H7uZ/",
    level: "进阶"
  },
  {
    title: "win10新系统必做的系统优化系列设置",
    description: "分享Windows 10系统安装后的必做优化设置，让系统运行更快更流畅。",
    thumbnail: (
      <svg width="320" height="180" viewBox="0 0 320 180" className="rounded-lg">
        <defs>
          <pattern id="pattern5" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
            <path d="M0 10h20M10 0v20" stroke="#e2e8f0" strokeWidth="1"/>
          </pattern>
        </defs>
        <rect width="320" height="180" fill="#f8fafc"/>
        <rect width="320" height="180" fill="url(#pattern5)"/>
        <circle cx="160" cy="90" r="40" fill="#3b82f6" opacity="0.1"/>
        <path d="M160 70 L190 110 L130 110 Z" fill="#3b82f6" opacity="0.3"/>
        <text x="160" y="140" textAnchor="middle" fill="#1e40af" fontSize="16" fontFamily="Arial">
          系统优化指南
        </text>
      </svg>
    ),
    videoUrl: "https://www.bilibili.com/video/BV11v411J7Ur/",
    level: "进阶"
  },
  {
    title: "驱动安装教程",
    description: "教你如何正确安装和更新系统驱动程序，解决常见驱动问题。",
    thumbnail: (
      <svg width="320" height="180" viewBox="0 0 320 180" className="rounded-lg">
        <defs>
          <pattern id="pattern6" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
            <circle cx="10" cy="10" r="2" fill="#e2e8f0"/>
          </pattern>
        </defs>
        <rect width="320" height="180" fill="#f8fafc"/>
        <rect width="320" height="180" fill="url(#pattern6)"/>
        <rect x="120" y="60" width="80" height="60" rx="10" fill="#3b82f6" opacity="0.2"/>
        <circle cx="160" cy="90" r="20" fill="#3b82f6" opacity="0.3"/>
        <text x="160" y="140" textAnchor="middle" fill="#1e40af" fontSize="16" fontFamily="Arial">
          驱动安装指南
        </text>
      </svg>
    ),
    videoUrl: "https://www.bilibili.com/video/BV1Fy4y1D7ZJ/",
    level: "入门"
  },
  {
    title: "Win10系统备份和还原",
    description: "详细讲解Windows 10系统的备份和还原方法，保护重要数据安全。",
    thumbnail: (
      <svg width="320" height="180" viewBox="0 0 320 180" className="rounded-lg">
        <defs>
          <pattern id="pattern7" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
            <path d="M0 0l20 20M20 0l-20 20" stroke="#e2e8f0" strokeWidth="1"/>
          </pattern>
        </defs>
        <rect width="320" height="180" fill="#f8fafc"/>
        <rect width="320" height="180" fill="url(#pattern7)"/>
        <circle cx="160" cy="90" r="30" fill="#3b82f6" opacity="0.1"/>
        <path d="M160 70 L190 110 L130 110 Z" fill="#3b82f6" opacity="0.3"/>
        <text x="160" y="140" textAnchor="middle" fill="#1e40af" fontSize="16" fontFamily="Arial">
          系统备份还原
        </text>
      </svg>
    ),
    videoUrl: "https://www.bilibili.com/video/BV1Dy4y1x7RP/",
    level: "进阶"
  },
  {
    title: "小白装机容易犯的9个错误",
    description: "总结新手装机时常见的9个错误，帮你避免踩坑。",
    thumbnail: (
      <svg width="320" height="180" viewBox="0 0 320 180" className="rounded-lg">
        <defs>
          <pattern id="pattern8" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
            <rect x="0" y="0" width="10" height="10" fill="#e2e8f0"/>
          </pattern>
        </defs>
        <rect width="320" height="180" fill="#f8fafc"/>
        <rect width="320" height="180" fill="url(#pattern8)"/>
        <circle cx="160" cy="90" r="40" fill="#3b82f6" opacity="0.1"/>
        <text x="160" y="90" textAnchor="middle" fill="#1e40af" fontSize="24" fontFamily="Arial" fontWeight="bold">
          ⚠️
        </text>
        <text x="160" y="120" textAnchor="middle" fill="#1e40af" fontSize="16" fontFamily="Arial">
          常见错误提醒
        </text>
      </svg>
    ),
    videoUrl: "https://www.bilibili.com/video/BV1ZM411i7kV",
    level: "入门"
  }
]

const Videos = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 py-8">
      <SEO 
        title="系统重装视频教程大全 | Windows/Mac装机视频教学合集"
        description="精选专业系统重装视频教程，包括Windows 10/11和Mac系统安装、U盘启动盘制作、驱动安装等详细视频教学，让你轻松学会电脑重装系统技巧。"
        keywords="装机视频教程,Windows重装系统视频,Mac系统安装视频,U盘启动制作教程,驱动安装视频教程,系统优化教程,重装系统视频教学,一键重装系统视频"
      />
      <motion.h1 
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-3xl font-bold text-primary mb-8 text-center flex items-center justify-center"
      >
        <FaFilm className="mr-3 text-primary" />
        视频教学合集
      </motion.h1>
      
      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {videos.map((video, index) => (
          <motion.div
            key={video.title}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
            className="card overflow-hidden"
          >
            <div className="relative">
              {video.thumbnail}
              <div className="absolute bottom-2 right-2 bg-black bg-opacity-75 text-white px-2 py-1 rounded text-sm">
                哔哩哔哩
              </div>
              <div className="absolute top-2 left-2 bg-primary text-white px-2 py-1 rounded text-sm">
                {video.level}
              </div>
            </div>
            <div className="p-4">
              <h3 className="text-xl font-semibold text-gray-800 mb-2">
                {video.title}
              </h3>
              <p className="text-gray-600 mb-4">
                {video.description}
              </p>
              <a
                href={video.videoUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block bg-primary text-white px-4 py-2 rounded-lg hover:bg-blue-600 transition-colors"
              >
                观看视频
              </a>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  )
}

export default Videos